import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

import { HOME_PATH } from "../../utils/textRoutes";

const MAIN_VIEWS = [
  { path: HOME_PATH, label: "Hoy" },
  { path: "/dashboard", label: "Panel" },
  { path: "/library", label: "Biblioteca" },
  { path: "/drawers", label: "Cajones" },
  { path: "/corkboard", label: "Corcho" },
  { path: "/kanban", label: "Kanban" },
  { path: "/vision", label: "Visión" },
  { path: "/atlas", label: "Atlas" },
  { path: "/help", label: "Ayuda" },
  { path: "/editor", label: "Editor" },
];

function resolveCrumbs(pathname) {
  if (pathname === "/" || pathname === "/hoy") {
    return [{ path: HOME_PATH, label: "Hoy", current: true }];
  }
  if (pathname === "/dashboard") {
    return [{ path: "/dashboard", label: "Panel", current: true }];
  }

  if (pathname.startsWith("/notas/") || pathname.startsWith("/a/")) {
    return [
      { path: "/dashboard", label: "Panel" },
      { path: "/library", label: "Biblioteca" },
      { path: pathname, label: "Artículo", current: true },
    ];
  }

  if (pathname.startsWith("/drawers")) {
    return [
      { path: "/dashboard", label: "Panel" },
      { path: "/drawers", label: "Cajones", current: true },
    ];
  }

  const match = MAIN_VIEWS.find(
    (v) => pathname === v.path || pathname.startsWith(`${v.path}/`)
  );

  if (match) {
    return [{ path: "/dashboard", label: "Panel" }, { ...match, current: true }];
  }

  return [
    { path: "/dashboard", label: "Panel" },
    { path: pathname, label: "Vista", current: true },
  ];
}

export default function NavBreadcrumb() {
  const { pathname } = useLocation();
  const crumbs = resolveCrumbs(pathname);

  return (
    <nav aria-label="Ubicación" style={styles.nav}>
      {crumbs.map((crumb, i) => (
        <React.Fragment key={`${crumb.path}-${i}`}>
          {i > 0 && <ChevronRight size={12} color="rgba(255,255,255,0.25)" style={{ flexShrink: 0 }} />}
          {crumb.current ? (
            <span style={styles.current}>{crumb.label}</span>
          ) : (
            <Link to={crumb.path} style={styles.link}>
              {crumb.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}

const styles = {
  nav: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    padding: "0 8px",
  },
  link: {
    color: "rgba(255,255,255,0.45)",
    textDecoration: "none",
    fontSize: "0.75rem",
    fontWeight: "600",
    whiteSpace: "nowrap",
    transition: "color 0.2s",
  },
  current: {
    color: "#D4AF37",
    fontSize: "0.75rem",
    fontWeight: "700",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
